import { render, staticRenderFns } from "./MeasuresContainer.vue?vue&type=template&id=18bc721b&"
import script from "./MeasuresContainer.vue?vue&type=script&lang=js&"
export * from "./MeasuresContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports